import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const LeanWaitingScreen = ({ modalRef }) => {
    const { waitAuthorizationTitle, waitAuthorizationSubtitle, leanSubtitleInfoBlock, gotItButton } = usePageMessages();
    const secondaryText = (
        <>
            <p>{waitAuthorizationSubtitle}</p>
            <br />
            <p>{leanSubtitleInfoBlock}</p>
        </>
    );
    return (
        <InfoPage
            dataTestId="lean-waiting-screen"
            insideModalComponent
            iconName="clock-80"
            iconColor="primary"
            headerText={waitAuthorizationTitle}
            secondaryText={secondaryText}
            primaryButtonCaption={gotItButton}
            primaryButtonOnClick={() => modalRef?.current?.close()}
        />
    );
};
export default LeanWaitingScreen;
